import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';

import type { GetCourseNftArgs } from './courses.types';

import {
  getCourseNftRequest,
  getCoursesRequest,
  getNftDetailRequest,
} from './courses.requests';

export const coursesInfiniteQueryOptions = () =>
  infiniteQueryOptions({
    queryFn: ({ pageParam }) => getCoursesRequest(pageParam),
    getNextPageParam: (lastPage) => lastPage.next_cursor,
    getPreviousPageParam: (firstPage) => firstPage.prev_cursor,
    initialPageParam: '',
    queryKey: ['courses'],
  });

export const nftDetailQueryOptions = (nftUuid: string) =>
  queryOptions({
    queryFn: () => getNftDetailRequest(nftUuid),
    queryKey: ['nft-details', { nftUuid }],
  });

export const courseNftInfiniteQueryOptions = ({
  courseUuid,
  search,
}: Omit<GetCourseNftArgs, 'cursor'>) =>
  infiniteQueryOptions({
    queryFn: ({ pageParam }) =>
      getCourseNftRequest({ courseUuid, cursor: pageParam, search }),
    getNextPageParam: (lastPage) => lastPage.next_cursor,
    getPreviousPageParam: (firstPage) => firstPage.prev_cursor,
    initialPageParam: '',
    queryKey: ['course-nft', { courseUuid, search }],
  });
